import { render } from "./TwoFAPopup.vue?vue&type=template&id=2b8e351c&ts=true"
import script from "./TwoFAPopup.vue?vue&type=script&lang=ts"
export * from "./TwoFAPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__